module.exports = __webpack_public_path__ + "static/media/icn-aluminio-08.9cac5246.svg";